module.exports = __webpack_public_path__ + "static/media/TimeTravelClue1.919f0031.png";